import type { HomeMaterialPreview, HomePublicConfig } from "../api/home-config";
import type { HomePart, HomeStage } from "../../../shared/home-config";

export type StoryMaterialSpec = HomeMaterialPreview;
export type HomeStoryShowcase = {
  materials: StoryMaterialSpec[];
  stages: Record<HomeStage, Partial<Record<HomePart, StoryMaterialSpec>>>;
  references: string[];
  model: { id: string; url: string } | null;
};
export function showcaseFromConfig(config: HomePublicConfig): HomeStoryShowcase {
  return { ...config.story, materials: Object.values(config.story.stages.material) };
}
